export enum GeneralTranslations {
  emailAddress = 'emailAddress',
  password = 'password',
  next = 'next',
  back = 'back',
  saveChanges = 'saveChanges',
  preview = 'preview',
}
